import React from "react";

// Page-level heading that lives in the page content (the top bar no longer
// renders a heading). Title on the left; optional action(s) — e.g. a primary
// "Create" button — passed as children, aligned to the right. Filters and other
// content render as siblings below this.
function PageHeading({ title, children }) {
  return (
    <div className="flex items-center justify-between mb-4 pl-1">
      <h1 className="text-xlg font-bold text-gray-900 dark:text-gray-100 mr-4">
        {title}
      </h1>
      {children ? (
        <div className="flex items-center gap-x-2">{children}</div>
      ) : null}
    </div>
  );
}

export { PageHeading };
